export default __webpack_public_path__ + "static/media/ahmedabad.4ae2b647.webp";